// extracted by mini-css-extract-plugin
var _1 = "webpack-components-FullTextBulkUploader-components-UploaderSection-module__UploaderSection";
var _2 = "webpack-components-FullTextBulkUploader-components-UploaderSection-module__UploaderSection--dashed";
var _3 = "webpack-components-FullTextBulkUploader-components-UploaderSection-module__UploaderSection--dragged";
var _4 = "webpack-components-FullTextBulkUploader-components-UploaderSection-module__UploaderSection--error";
export { _1 as "UploaderSection", _2 as "UploaderSection--dashed", _3 as "UploaderSection--dragged", _4 as "UploaderSection--error" }
